import {DSButton} from "@cdx/ds";
import {TreeStore} from "./useVisionBoardData";
import {useEffect, useState} from "react";
import {useGlobalKeyPress} from "@cdx/common";

type UndoButtonsProps = {
  store: TreeStore;
};
const UndoButtons = ({store}: UndoButtonsProps) => {
  const [canUndo, setCanUndo] = useState(() => store.undoManager.canUndo());
  const [canRedo, setCanRedo] = useState(() => store.undoManager.canRedo());

  useGlobalKeyPress({
    key: "z",
    withMod: true,
    fn: () => {
      store.undoManager.undo();
    },
  });
  useGlobalKeyPress({
    key: "z",
    withMod: true,
    withShift: true,
    fn: () => {
      store.undoManager.redo();
    },
  });
  useGlobalKeyPress({
    key: "y",
    withMod: true,
    fn: () => {
      store.undoManager.redo();
    },
  });

  useEffect(() => {
    const handle = () => {
      setCanUndo(store.undoManager.canUndo());
      setCanRedo(store.undoManager.canRedo());
    };
    store.undoManager.on("stack-item-added", handle);
    store.undoManager.on("stack-item-popped", handle);
    return () => {
      store.undoManager.off("stack-item-added", handle);
      store.undoManager.off("stack-item-popped", handle);
    };
  }, [store.undoManager]);

  return (
    <>
      <DSButton onClick={() => store.undoManager.undo()} disabled={!canUndo}>
        Undo
      </DSButton>
      <DSButton onClick={() => store.undoManager.redo()} disabled={!canRedo}>
        Redo
      </DSButton>
    </>
  );
};

export default UndoButtons;
